// ARIA roles used in implicit role mapping
export const ARIA_ROLES = {
  ARTICLE: "article",
  BLOCKQUOTE: "blockquote",
  BUTTON: "button",
  CAPTION: "caption",
  CELL: "cell",
  CHECKBOX: "checkbox",
  CODE: "code",
  COMBOBOX: "combobox",
  COMPLEMENTARY: "complementary",
  CONTENTINFO: "contentinfo",
  DELETION: "deletion",
  DIALOG: "dialog",
  DOCUMENT: "document",
  EMPHASIS: "emphasis",
  FIGURE: "figure",
  FORM: "form",
  GENERIC: "generic",
  GROUP: "group",
  HEADING: "heading",
  IMG: "img",
  INSERTION: "insertion",
  LINK: "link",
  LIST: "list",
  LISTBOX: "listbox",
  MAIN: "main",
  METER: "meter",
  NAVIGATION: "navigation",
  OPTION: "option",
  PARAGRAPH: "paragraph",
  PROGRESSBAR: "progressbar",
  RADIO: "radio",
  ROW: "row",
  ROWGROUP: "rowgroup",
  SEARCH: "search",
  SEARCHBOX: "searchbox",
  SEPARATOR: "separator",
  SLIDER: "slider",
  SPINBUTTON: "spinbutton",
  STATUS: "status",
  STRONG: "strong",
  TABLE: "table",
  TERM: "term",
  TEXTBOX: "textbox",
  TIME: "time",
} as const;
